import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { Primary, Text, TextFontSizes, TextFontWeights, TextLineHeights } from "@cinch-labs/design-system";
import styles from "./ready-to-get-car-finance.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { searchAllCarsClick } from "../../tracking/tracking-events";
function ReadyToGetCarFinance({ i18n , className  }) {
    const { trackEvent  } = useAnalytics();
    return /*#__PURE__*/ _jsx("article", {
        className: cx(styles.readyToGetCarFinance, className),
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    element: "h2",
                    fontSize: TextFontSizes["4xl"],
                    fontWeight: TextFontWeights.bold,
                    lineHeight: TextLineHeights.display,
                    className: styles.readyToGetCarFinanceMainTitle,
                    children: i18n.title
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: TextFontSizes.s,
                    fontWeight: TextFontWeights.book,
                    children: i18n.text
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.readyToGetCarFinanceButton,
                    children: /*#__PURE__*/ _jsx(Primary, {
                        "data-testid": "search-all-cars-button",
                        element: "a",
                        href: "/used-cars",
                        onClick: ()=>trackEvent(searchAllCarsClick()),
                        children: "Search all cars"
                    })
                })
            ]
        })
    });
}
export default ReadyToGetCarFinance;
